import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@99designs/react-components/components/Button';
import Icon from '@99designs/react-components/components/Icon';
import EntryPlaceholder from './entry-placeholder';
import ConfirmationPopup from './confirmation-popup';
import pluralSelect from '../../../utils/plural-select';
import Drawer from './drawer';

class SelectWinnerDrawer extends Component {
    render() {
        const entryCount = this.props.entries.length;
        return (
            <Drawer>
                <div className="drawer-item-list">
                    {this.props.entries.map((entry, index) => (
                        <div className="drawer-item-list__item" key={entry.designId}>
                            {this.renderEntry(entry, index)}
                        </div>
                    ))}
                    <div className="drawer-item">
                        <EntryPlaceholder size={48} />
                    </div>
                </div>
                <div className="drawer-item-list drawer-item-list--right">
                    <div className="drawer-item-list__item">
                        {this.renderAdditionalWinnerPrice()}
                        <Button onClick={this.props.onConfirm} isDisabled={entryCount === 0}>
                            <FormattedMessage
                                id={pluralSelect(entryCount, {
                                    zero: 'select_winner_drawer_button_confirm_zero',
                                    one: 'select_winner_drawer_button_confirm_one',
                                    other: 'select_winner_drawer_button_confirm_other',
                                })}
                                values={{ entryCount }}
                            />
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }

    renderEntry(entry, index) {
        const showConfirmationPopup = this.props.entriesNeedingPopup.includes(entry);
        return (
            <ConfirmationPopup
                isActive={showConfirmationPopup}
                variations={['small']}
                content={<FormattedMessage id="select_winner_drawer_confirmation" />}
            >
                <div className="drawer-item drawer-item--with-shadow">
                    <div className="drawer-item__content">
                        <img src={entry.imageUrl} />
                    </div>
                    <div className="drawer-item__remove">
                        <button
                            className="solid-icon-button"
                            onClick={() => this.props.onRemoveWinner(index)}
                        >
                            <Icon variations={['x-3']} />
                        </button>
                    </div>
                </div>
            </ConfirmationPopup>
        );
    }

    renderAdditionalWinnerPrice() {
        const winnerCount = this.props.entries.length;
        if (winnerCount > 1) {
            return (
                <span style={{ padding: '0 15px' }}>
                    <FormattedMessage
                        id={pluralSelect(winnerCount, {
                            one: 'select_winner_drawer_additional_winner_one',
                            other: 'select_winner_drawer_additional_winner_other',
                        })}
                    />
                    {' ' + this.props.additionalWinnerCostTotal}
                </span>
            );
        }
    }
}

SelectWinnerDrawer.propTypes = {
    entries: PropTypes.arrayOf(
        PropTypes.shape({
            designId: PropTypes.number.isRequired,
            imageUrl: PropTypes.string.isRequired,
        })
    ).isRequired,
    entriesNeedingPopup: PropTypes.array.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onRemoveWinner: PropTypes.func.isRequired,
    additionalWinnerCostTotal: PropTypes.string.isRequired,
};

export default SelectWinnerDrawer;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/select-winner-drawer.jsx